import { Link } from 'react-router';

import { paths } from '@/app/routes/paths';
import { messages } from '@/shared/i18n';

export function SalaamahLogo({ to = paths.root }: { to?: string }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand/50"
      aria-label={messages.auth.logoAriaLabel}
    >
      <img
        src="/auth/salaamah-logo.svg"
        alt=""
        width={135}
        height={30}
        className="h-[26px] w-auto sm:h-[30px]"
        decoding="async"
      />
    </Link>
  );
}
